import Dashboards from '@highcharts/dashboards';
import DataPoolOptions from '@highcharts/dashboards/es-modules/Data/DataPoolOptions';
import ChartColumn from '../Charts/ChartColumn';
import SubChartBar from '../Charts/SubCharts/SubChartBar';
import { EditModeConfig, GuiConfig, DashboardConfig, SUB_CHART_LIMIT, dateAggregationMap } from './DefaultConfig';
import { DataFunctions } from '../../Utils/dataFunctions';
import { TenantConfigType } from '../../Utils/utils';

const PatientWaitTimes = ({
  data,
  subChartData,
  seeMoreBottomLeft,
  seeMoreBottomRight,
  dateRange,
  tenantConfig,
  ...rest
}: DashboardConfig): Dashboards.Board.Options => ({
  dataPool: dataPoolConfig(data, subChartData, seeMoreBottomLeft, seeMoreBottomRight, dateRange, tenantConfig),
  editMode: EditModeConfig,
  gui: GuiConfig,
  components: [
    ChartColumn({
      selectedPoint: rest.filterOverride,
      leftSeriesTitle: 'Average sim to treatment time (Days)',
      rightSeriesTitle: '',
      leftSeriesFields: ['Date', 'Sim to treat'],
      rightSeriesFields: ['Date', ''],
      aggregation: dateAggregationMap[dateRange],
      dateRange: dateRange,
      tooltipSuffix: '',
      tooltipPrecision: 1,
      ...rest,
    }).components?.[0] ?? {},
    SubChartBar({
      seeMore: seeMoreBottomLeft,
      title: 'Physicians',
      connector: 'sub-chart-left-data',
      cell: 'sub-chart-left',
      dataLabelTitle: 'Average sim to treatment time (Days)',
      dataLabelTitleWidth: 120,
      precision: 1,
      yAxisMax: DataFunctions.calcAverageSimToTreat(data, tenantConfig) * 2,
      dataLength: DataFunctions.aggregateData(subChartData, 'createdBy').length - 1,
      numLabels: 1,
      ...rest,
    }).components?.[0] ?? {},
  ],
});

const dataPoolConfig = (
  data: any,
  subChartData: any,
  seeMoreBottomLeft: boolean,
  seeMoreBottomRight: boolean,
  dateRange: string | undefined,
  tenantConfig: TenantConfigType,
): DataPoolOptions => ({
  connectors: [
    {
      id: 'top-chart-data',
      type: 'JSON',
      options: {
        firstRowAsNames: false,
        columnNames: ['Date', 'Sim to treat'],
        data: DataFunctions.aggregateAverageSimToTreat(data, dateAggregationMap[dateRange!], tenantConfig),
      },
    },
    {
      id: 'sub-chart-left-data',
      type: 'JSON',
      options: {
        data: DataFunctions.calcAverageSimToTreatPerPhysician(
          subChartData,
          tenantConfig,
          seeMoreBottomLeft ? undefined : SUB_CHART_LIMIT,
        ),
      },
    },
    {
      id: 'sub-chart-right-data',
      type: 'JSON',
      options: {
        data: [],
      },
    },
  ],
});

export default PatientWaitTimes;
